module.exports = __webpack_public_path__ + "img/location_pin.85fa6db8.svg";